'use client'
import Link from 'next/link'

// India-specific social links
const indiaNavigation = {
  social: [
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/ai-forge-india/?viewAsMember=true',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: 'YouTube',
      href: 'http://www.youtube.com/@AIForgeIndia',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/aiforgeindia/',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
  ],

}

export function IndiaFooter() {
  return (
    <footer
      className="bg-gradient-to-r from-[#02090e] to-[#01080c] relative w-full border-t border-slate-800/50"
      aria-labelledby="india-footer-heading"
    >
      <h2 id="india-footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-20 lg:px-8">
        {/* 5-column centered layout */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 xl:gap-6 items-start">
          {/* Column 1: Program */}
          <div className="text-center">
            <h3 className="text-sm font-semibold text-white mb-4">Program</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/india/about"
                  className="text-sm leading-6 !no-underline !text-gray-400 hover:text-white transition"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  href="/india/events"
                  className="text-sm leading-6 !no-underline !text-gray-400 hover:text-white transition"
                >
                  Events
                </Link>
              </li>
              <li>
                <Link
                  href="https://www.aiforge.org/signup?role=founder"
                  className="text-sm leading-6 !no-underline !text-gray-400 hover:text-white transition"
                >
                  Apply
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 2: Community */}
          <div className="text-center">
            <h3 className="text-sm font-semibold text-white mb-4">Community</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/india/team"
                  className="text-sm leading-6 !no-underline !text-gray-400 hover:text-white transition"
                >
                  Team
                </Link>
              </li>
              <li>
                <Link
                  href="/india/mentors"
                  className="text-sm leading-6 !no-underline !text-gray-400 hover:text-white transition"
                >
                  Mentors
                </Link>
              </li>
              <li>
                <Link
                  href="/india/portfolio"
                  className="text-sm leading-6 !no-underline !text-gray-400 hover:text-white transition"
                >
                  Portfolio
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Logo and tagline (middle) */}
          <div className="col-span-2 md:col-span-1 flex flex-col items-center gap-4 text-center">
            <Link href="/india" className="pb-2">
              <img
                className="h-14 md:h-16 w-auto mx-auto"
                src="/images/home/ai-forge-india-logo.png"
                alt="AI Forge India Logo"
              />
            </Link>
            <p className="text-sm text-gray-400 max-w-xs">
              India's premier AI incubator program. Build, scale, and launch your AI startup.
            </p>
            <p className="text-sm text-gray-400">
              Contact us at -{' '}
              <a
                href="mailto:india@aiforge.org"
                className="text-orange-500 hover:text-orange-400 transition !no-underline"
              >
                india@aiforge.org
              </a>
            </p>
          </div>

          {/* Column 4: Resources */}
          <div className="text-center">
            <h3 className="text-sm font-semibold text-white mb-4">Resources</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/india/partners"
                  className="text-sm leading-6 !no-underline !text-gray-400 hover:text-white transition"
                >
                  Partners
                </Link>
              </li>
              <li>
                <Link
                  href="/jobs"
                  className="text-sm leading-6 !no-underline !text-gray-400 hover:text-white transition"
                >
                  Jobs
                </Link>
              </li>
              <li>
                <Link
                  href="/media"
                  className="text-sm leading-6 !no-underline !text-gray-400 hover:text-white transition"
                >
                  Media
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 5: Legal */}
          <div className="text-center">
            <h3 className="text-sm font-semibold text-white mb-4">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/privacy"
                  className="text-sm leading-6 !no-underline !text-gray-400 hover:text-white transition"
                >
                  Privacy
                </Link>
              </li>
              <li>
                <Link
                  href="/terms"
                  className="text-sm leading-6 !no-underline !text-gray-400 hover:text-white transition"
                >
                  Terms
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar with copyright and social links */}
        <div className="w-full mt-12 border-t border-slate-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs leading-5 !no-underline !text-gray-400">
            &copy; {new Date().getFullYear()} AI Forge, Inc. All rights reserved.
          </p>
          <div className="flex space-x-6">
            {indiaNavigation.social.map((item) => (
              <a
                key={item.name}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="!no-underline !text-gray-500 hover:text-orange-500 transition"
              >
                <span className="sr-only">{item.name}</span>
                <item.icon className="h-5 w-5" aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>

        {/* Back to global site link */}
        <div className="mt-8 text-center">
          <Link
            href="/"
            className="text-xs text-gray-500 hover:text-orange-500 transition !no-underline"
          >
            ← Back to AI Forge Global
          </Link>
        </div>
      </div>
    </footer>
  )
}
